// FEAT-049: RU(Russia) SMARTDent standalone 바우처 전용 redeem 도메인 분기 (SSoT).
// 발급 대상 조직(dealerId)의 국가가 'RU' 이면 redeem base 를 RU 도메인으로 치환.
// 특정 companyId 목록이 아니라 국가(country==='RU')로 판정한다 — 대상 회사가
// 모두 country='RU' 이므로 회사 목록은 불필요, 국가 기준이 SSoT (사용자 확정 2026-07-20).
// 기본 qrpath 는 env-aware(product-package 소스, dev=raydevelop) 이나, RU redeem 은
// prod 전용 외부 도메인(ru.rayplatform.com)만 존재하므로 env 분기 없이 prod 고정이 의도된 동작이다.
import { resolveLicenseProduct } from './licenseProduct';

export const RU_REDEEM_QRPATH = 'https://ru.rayplatform.com/redeem?code';

export const isRuRedeemTarget = (dealerId, companyMap) =>
    companyMap?.[dealerId]?.country === 'RU';

// product 생략 = SMARTDent(현행). RU 주소는 ruRedeem 제품 + RU 대상일 때만, 목록 밖 product 는 기본 qrpath.
export const resolveRedeemQrpath = (defaultQrpath, dealerId, companyMap, product) => {
    const resolved = resolveLicenseProduct(product, { handler: 'voucherRedeem.resolveRedeemQrpath' });
    return resolved?.ruRedeem && isRuRedeemTarget(dealerId, companyMap)
        ? RU_REDEEM_QRPATH
        : (defaultQrpath || null);
};

// FEAT-022 기존 로직 이식: qrpath 있으면 full URL, 없으면 raw token(legacy).
export const buildQrValue = (qr, qrpath) => {
    if (!qr?.token) return '';
    if (!qrpath) return qr.token;
    const type = qr.type || 'initial';
    return `${qrpath}=${type}-${qr.token}`;
};
